interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Doge = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26553)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#B49723"
      />
      <path
        d="M46.3219 20.0022C42.243 20.0022 29.081 20.0022 29.081 20.0022V46.7105H22V53.2522H29.0813V79.9604H49.1703C49.1703 79.9604 77.4172 82.3269 77.4172 50.4815C77.4172 19.1553 50.4013 20.0022 46.3219 20.0022ZM48.7082 68.8769C46.5726 68.8769 40.3954 68.8769 40.3954 68.8769V53.2524H52.8644V46.7107H40.3954V31.0857C40.3954 31.0857 45.3596 31.0857 48.3231 31.0857C51.2866 31.0857 66.1988 32.2784 66.2215 50.6981C66.2448 69.1176 50.8436 68.8769 48.7082 68.8769Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26553">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
